import styled, { ThemeProvider, useTheme } from 'styled-components';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { View } from 'foundations-components/components/View';
import { RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledClickable = styled(Clickable)(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    borderBottom: `1px solid ${theme.color['border-core-subtle']}`,
    padding: '10px 20px',
    width: '100%',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '100%',
    paddingLeft: '30px',
    ':last-of-type': {
      borderBottom: 'none'
    }
  };
});
export default function MobilePanelNavItem({
  children,
  itemId,
  onClickItem,
  title
}) {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: theme,
    children: [/*#__PURE__*/_jsxs(StyledClickable, {
      onClick: () => onClickItem(itemId),
      children: [title, /*#__PURE__*/_jsx(View, {
        children: children && /*#__PURE__*/_jsx(RightIcon, {
          color: "fill-info-default",
          size: "600"
        })
      })]
    }), children]
  });
}